var totalAllowedQty = 5;
// var surpriseProductID = 11589973441;
//var surpriseProductID = 25387964675;
var surpriseProductID = 31434506500; //staging2 id

function follow_Screen() {
  if($(window).width() >= 768) {
    var element_left = $('.follow-scroll-left'),
        originalY_left = element_left.offset().top;
    var element_right = $('.follow-scroll-right'),
        originalY_right = element_right.offset().top;

    // Space between element and top of screen (when scrolling)
    var topMargin = 20;

    // Should probably be set in CSS; but here just for emphasis
    element_left.css('position', 'relative');
    element_right.css('position', 'relative');

    $(window).on('scroll', function(event) {
      var scrollTop = $(window).scrollTop();
//       var nextPosition = scrollTop - originalY_right + topMargin;
//       var maxPositionAllowed = 4400;


      element_left.stop(false, false).animate({
        top: scrollTop < originalY_left
        ? 0
        : scrollTop - originalY_left + topMargin
      }, 300);

      element_right.stop(false, false).animate({
        top: scrollTop < originalY_right
        ? 0
        : scrollTop - originalY_right + topMargin  // Math.min(nextPosition, maxPositionAllowed) 
      }, 300);
    });
  }
  else {
 /*   var element_left = $('.follow-scroll-left');

    // Space between element and top of screen (when scrolling)
    var topMargin = 20;

    // Should probably be set in CSS; but here just for emphasis
    element_left.css('position', 'relative');

    $(window).on('scroll', function(event) {
      var scrollTop = $(window).scrollTop();
      if(scrollTop > 200) {
        element_left.css({ position: 'fixed', top: 0, left: 0, zIndex: '1000', width: "100%", padding: '2px 10px 2px 10px' });
      }
      else {
        element_left.removeAttr("style");
      }
    });*/
  }
}
(function($) {
  if($(window).width() < 769) {
    $("a.proceed").hide();
    $("a.proceed-mobile").hide();
  }
  $(".blury-container").show();
  $(".choose-snack").click(function() {
    // enable body scroll
    $('body').css('overflow-y', 'initial');
    $("#chosen-snack-type").val($(this).data("snacktype"));
    if($(this).data("snacktype") == "1") {
      $("a.proceed").click();
    }
    else {
      follow_Screen();
//        $(".choose-from-main-snack").fadeOut(500, function() {
//         $(".blury-container").fadeOut(500, function() {
//            follow_Screen();
//            if($(window).width() < 769) {
//              $("a.proceed-mobile").show();
//              
//            }
//          });
//        });
    }
  });

  if($(window).width() < 768) {
    if($.cookie('dont-worries-popup') == undefined) {
      $("#dont-worries-mobile").fadeIn(500);
    }
     $(".ok-button").click(function() {
       // disable body scroll
       //$('body').css('overflow-y', 'hidden');
       
       $.cookie('dont-worries-popup', 'true', { expires: 7 });
       $("#dont-worries-mobile").fadeOut(500);
       // scroll to product-middle-part
       var target = $('.product-middle-part');
       if( target.length ) {
         event.preventDefault();
         $('html, body').stop().animate({
           scrollTop: target.offset().top - 20
         }, 500);
       }
     });
    $(".cancel-button").click(function() {
      $(this).closest(".are-you-sure").fadeOut(500);
    });
    $(".yes-button").click(function() {
      var surpriseQty = $.trim($(".remaining:first").html());
      $.post('/cart/add.js', {
        quantity: surpriseQty,
      //  id: "11589973441"
          id: surpriseProductID
      }, function(data) {
        var html = $("#cart_template").val();
        var img = data.image.split("/")[data.image.split("/").length -1];
        img = img.replace(".", "_large.");
        img = data.image.replace(data.image.split("/")[data.image.split("/").length -1], img);

        html = html.replace("#itemID#", data.id).replace("#ID#", data.id).replace("#TITLE#", data.product_title + " X " + surpriseQty).replace("#IMG#", img).replace("#QTYADDED#", surpriseQty);
        var isFound = false;
        $(".cart-right li").each(function() {
          if($(this).find(".added-cart").index() == -1 && !isFound) {
            $(html).insertAfter($(this).find(".note-pick"));
            $(this).find(".note-pick").hide();
            isFound = true;
          }
        });
        var totalItem = parseInt($(".added").html());
        totalItem = parseInt(totalItem) + parseInt(surpriseQty);
        $(".added").html(totalItem);
        $('.cart-items').text(totalItem);
        $(".remaining").html(parseInt(totalAllowedQty) - parseInt(totalItem));
        if(totalItem >= totalAllowedQty) {
          $(".suprise-click").hide();
          $(".are-you-sure").hide();
          $(".surprise-box").fadeOut(500, function() {
            $(".a-proceed-box, .schedule-box").fadeIn(500);
            if($(window).width() < 768) {
              $("a.proceed").click();
            }
          });
        }
      }, 'json');
    });
    $(".popup-cart, .cart-right .pick-a-snack, .surprise-box > .proceed-box").click(function() {
      
      if($(".product-right-part").is(":visible")) {
        $(".product-right-part").fadeOut(500);
      }
      else {
        $(".product-right-part").fadeIn(500);
      }
      
      $('.a-proceed-box.mobile-show-hard').toggleClass('z-1000');
      $('.a-proceed-box.mobile-show-hard .goto').toggleClass('v-hidden');
    });
  }
  
  // show added product as ADDED instead of ADD TO CART on Reload page
  $.getJSON("/cart.js", function(data){
    if(Object.keys(data.items).length > 0) {
      //alert(JSON.stringify(data.items));
        $.each(data.items, function(i, item){
            //alert(JSON.stringify(item.id));
          $('.middle-part-sec-2').find("[data-id='" + item.id + "']").addClass('active').val('Added');
        });
    }
  });
  
})(jQuery);

var lastPopupObj;
jQuery(document).ready(function() {
  $(".cart-right li .title").each(function() {
    if($.trim($(this).html()) == "Mini Fab Box" || $.trim($(this).html()) == "Try One Box - Try One Box" || $.trim($(this).html()) == "3 Months Subscription" || $.trim($(this).html()) == "6 Months Subscription") {
      var obj = $(this);
      setTimeout(function() {
        obj.parent().find(".cart").trigger("click");
        window.location.reload();
      }, 1000);
    }
  });
  
// Empty cart Function
  
  $('.empty-cart').on('click',function(){
      $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        async: false,
        cache: false,
        success: emptyCart,
        dataType: 'json'
      });    
  }); 
    
    function emptyCart(data){
      // Update added and remaining items count
       $('.follow-scroll-right .note .added').html('0');
       //$('.follow-scroll-right .note .remaining').html('5');
       $('.remaining').html('5');
      // For mobile
      $('.popup-cart .cart-items').html('0');
      // Update surprise popup added and remaining
      $('.surprise-popup .cart-items').html('0');
      $('.surprise-popup .remaining').html('5');
      
	  // Pick a snack note
       $('.cart-right .added-cart').each(function(){
            $(this).prev(".note-pick").removeClass('hide');
            $(this).remove();
        });
      // Remove Proceed button and show surprise and update suprise remaining item 
        $(".suprise-click").show().find('.remaining').html('5');
        $(".a-proceed-box, .schedule-box").fadeOut(500, function() {
          $(".surprise-box").fadeIn(500);
        });
      // Update Add To Box button
        $('.addtocart-custom-new.active').each(function() {
			$(this).removeClass('active').val('Add To Box');
        });
      
      // Remove extra li if present
      if($('.cart-right li').length > 5) {
        $('.cart-right li').slice(5, $('.cart-right li').length).remove();
      }
      
      // Show all the item <li>
        $(".note-pick").not(":visible").each(function() {
            $(this).closest("li").show();
          });
   }
  
  
  /* Step 1 Start */
  
//   Add to cart function
  
  $('.addtocart-custom-new').on("click", function test (e) {
    var lastClicked = $(this).data("lastClicked") || 0;
	e.preventDefault();
	$('.addtocart-custom-new').off("click", 'test');
	  if ( (new Date() - lastClicked >= 1500) || lastClicked == 0) {
        $(this).data("lastClicked", new Date());
		addToCart($(this));
	  }
});
  
  function addToCart (ele) {
  	if(parseInt($(".added").html()) < totalAllowedQty) {
      console.log("added");
      var id = ele.data("id");
      var object = ele;
      var itemTitle = '';
      var addToItemQTY = '';
      $.post('/cart/add.js', {
        quantity: 1,
        id: id
      }, function(data) {
        var html = $("#cart_template").val();
        var img = data.image.split("/")[data.image.split("/").length -1];
        img = img.replace(".", "_large.");
        img = data.image.replace(data.image.split("/")[data.image.split("/").length -1], img);
        itemTitle = data.product_title;
        addToItemQTY = data.quantity;
        
        html = html.replace("#itemID#", data.id).replace("#ID#", data.id).replace("#TITLE#", data.product_title).replace("#IMG#", img).replace("#QTYADDED#", "1");
        var isFound = false;
        object.addClass("active");
        object.val("Added");
        /* setTimeout(function() {
          object.val("Add To Box");
        }, 3000); */
        
        $(".cart-right li").each(function() {
          if($(this).find(".added-cart").index() == -1 && !isFound) {
            $(html).insertAfter($(this).find(".note-pick"));
            $(this).find(".note-pick").addClass('hide');
            
            isFound = true;
          }
        });
        
        var totalItem = parseInt($(".added").html());
        totalItem++;
        $(".added").html(totalItem);
        $('.cart-items').text(totalItem);
        $(".remaining").html(totalAllowedQty - totalItem);
        if(totalItem >= totalAllowedQty) {
          $(".suprise-click").hide();
          $(".surprise-box").fadeOut(500, function() {
            $(".a-proceed-box ,.schedule-box").fadeIn(500);
          });
        }
        
        var addedItems = [];
        var addToItemId = id;

        $('.cart-right div.added-cart').each(function() {
          addedItems.push($(this).data('id'));
        });
        
        if( addedItems.indexOf(addToItemId) != -1 ) {
          var $ele = $(".cart-right div.added-cart[data-id='" + addToItemId + "']:first");
          console.log('addToItemQTY: ' + addToItemQTY);
          if(addToItemQTY > 1) {
            $ele.find('.title').html(itemTitle + ' <span class="item-multi"> X </span> <span class="item-title-qty">' + addToItemQTY + '</span>' );
            $ele.find('.cart.remove').attr('data-qty', addToItemQTY);
          }
          
          $(".cart-right div.added-cart[data-id='" + addToItemId + "']:not(:first)").prev().addClass('hide');
          $(".cart-right div.added-cart[data-id='" + addToItemId + "']:not(:first)").parent('li').hide();          
        }
        
        // show added item as alert fade popup
       var triangleup = $(".triangle-up");
		var mobileCartContainer = $(".mobile-cart-container");
            mobileCartContainer.html("");
            mobileCartContainer.html($(".cart-right").clone());
        	mobileCartContainer.append('<div class="triangle-up"> <div class="inner-triangle"></div> </div>');
            $(".mobile-cart-container li").each(function() {
              if($(this).find(".added-cart").index() == -1)
                $(this).remove();
            });
        	mobileCartContainer.fadeIn();
        	setTimeout(function(){ mobileCartContainer.fadeOut(800); }, 2000);
        // End

      }, 'json');
    }
    else {
      alert("Oops! you have already chosen 5 items.");
    }
  }
  
// 
  
  
// Let it be surprise functionality  
  $('.let-surprise').click(function() {
      console.log('.let-surprise clicked');
    if(parseInt($(".added").html()) < totalAllowedQty) {
//       var id = "11589973441"
      var id = surpriseProductID;
      $.post('/cart/add.js', {
          quantity: 1,
          id: id
      }, function(data) {
      	var html = $("#cart_template").val();
        var img = data.image.split("/")[data.image.split("/").length -1];
        img = img.replace(".", "_large.");
        img = data.image.replace(data.image.split("/")[data.image.split("/").length -1], img);
        
        html = html.replace("#itemID#", data.id).replace("#ID#", data.id).replace("#TITLE#", data.product_title).replace("#IMG#", img).replace("#QTYADDED#", "1");
        var isFound = false;
        
        $(".cart-right li").each(function() {
          if($(this).find(".added-cart").index() == -1 && !isFound) {
            $(html).insertAfter($(this).find(".note-pick"));
            $(this).find(".note-pick").addClass('hide');
            isFound = true;
          }
        });
        
        
        var addedEle = $(".added");
        var remainEle = $(".remaining");
        var addedItems = parseInt(addedEle.html());
        var remainItems = parseInt(remainEle.html());
        var updatedAddedItems = addedItems+1;
        var updatedRemainItems = remainItems-1;
        
        // Update added and remaining items count
        addedEle.html(updatedAddedItems);
        remainEle.html(updatedRemainItems);
        // for mobile
      	$('.popup-cart .cart-items').html(updatedAddedItems);
    	$('.surprise-popup .cart-items').html(updatedAddedItems);
        
//         var totalItem = parseInt($(".added").html());
//         totalItem++;
//         $(".added").html(totalItem);
//         $('.cart-items').text(totalItem);
//         $(".remaining").html(totalAllowedQty - totalItem);
        if(updatedAddedItems >= totalAllowedQty) {
          $(".suprise-click").hide();
          $(".surprise-box").fadeOut(500, function() {
            $(".a-proceed-box, .schedule-box").fadeIn(500);
          });
        }
		
      }, 'json');

  	}
  });
  
  
  $(".cart-right").on("click", ".remove", function() {
    
    var objRemove = $(this).closest(".added-cart");
    
    var addedEle = $(".added");
    var remainEle = $(".remaining");
    var addedItems = parseInt(addedEle.html());
    var remainItems = parseInt(remainEle.html());
    var updatedAddedItems = addedItems-1;
    var updatedRemainItems = remainItems+1;

    var itemQTY = parseInt($(this).data('qty'));
    var removeIndex = $(this).closest("li").index();
    var removeItemId = objRemove.data('id');
    var updatedItemQTY = itemQTY-1;
    
    if( itemQTY > 1 && removeItemId != surpriseProductID ) {
      // Update data-dty 
      $(this).data('qty', updatedItemQTY); // it will update data value but wont reflect in html
      
      // Update current Pick a box li - title qty
      if (updatedItemQTY == 1) 
        objRemove.find('.item-title-qty , .item-multi').html('');
      else 
        objRemove.find('.item-title-qty').html(updatedItemQTY);
      
      // Update Pick a box li - show one more pick a box
      var pickBox = $(".follow-scroll-right > .cart-right .added-cart[data-id='" + removeItemId + "']:last");
      	pickBox.parent('li').show();
        pickBox.prev('.note-pick').removeClass('hide');
        pickBox.remove();
  	}
    
    else if (itemQTY > 1 && removeItemId == surpriseProductID) {
      // Remove item from pick a box 
      objRemove.prev(".note-pick").removeClass('hide');
      objRemove.remove();
      $('.follow-scroll-right > .cart-right li:hidden').each(function() {
        if($(this).find('.added-cart').length == 0){
        	$(this).show();
        }
        else if($(this).find('.added-cart').data('id') == surpriseProductID) {
        	$(this).find('.added-cart').remove();
          	$(this).show();
        }
      });
    }
    else {
      // Remove item from pick a box 
      	objRemove.prev(".note-pick").removeClass('hide');
    	objRemove.remove();
    }
    
    if (removeItemId != surpriseProductID) {
   	  // Update added and remaining items count
        addedEle.html(updatedAddedItems);
        remainEle.html(updatedRemainItems);
      // for mobile
      	$('.popup-cart .cart-items').html(updatedAddedItems);
    	$('.surprise-popup .cart-items').html(updatedAddedItems);
    }
    else {
      // Update added and remaining items count
        addedEle.html(addedItems-itemQTY);
        remainEle.html(remainItems+itemQTY);
      // for mobile
      	$('.popup-cart .cart-items').html(addedItems-itemQTY);
    	$('.surprise-popup .cart-items').html(addedItems-itemQTY);
    }

//     var objThis = $(this);
       
    // Update Proceed button and show surprise and update suprise remaining item 
      if(updatedAddedItems < totalAllowedQty) {
        $(".suprise-click").show();
        $(".a-proceed-box , .schedule-box").fadeOut(500, function() {
          $(".surprise-box").fadeIn(500);
        });
      }
    
    // Remove Item from shopify cart and Update Add To Box button
    var removeItemURL = $(this).data("href");
    if(removeItemId != surpriseProductID) // not surprise pack
      removeItemURL = removeItemURL.replace("=0", "="+parseInt(updatedItemQTY));
    else if(itemQTY == 1 && removeItemId == surpriseProductID) {
      	var remainSurpriseCount = $(".follow-scroll-right .added-cart[data-id='" + removeItemId + "']").length;
    	removeItemURL = removeItemURL.replace("=0", "="+parseInt(remainSurpriseCount));
    }
    
    $.get(removeItemURL, function() {
      // Update Add to Box button
      var addedItems = [];

      $('.follow-scroll-right > .cart-right div.added-cart').each(function() {
        addedItems.push($(this).data('id'));
      });

      if( addedItems.indexOf(removeItemId) == -1 ) {
        $("[data-id='" + removeItemId + "']").removeClass('active').val('Add To Box');
      }
    });
  
  });
  
  
  $(".follow-scroll-left ul li a").click(function() {
    $(".follow-scroll-left ul li a").removeClass("active");
    $(this).addClass("active");
  });
  $(".animation-zoom").click(function() {
    lastPopupObj = $(this).data("href");
    var url = $($(this).data("href")).data("url");
    var objInner = this;
    $(".description-div").html("");
    
    $($(this).data("href") + " .product-description").load(url + " .description-div", function() {
      if($.trim($(".description-div").find(".description").html()) == "") {
        $(".description-div").html("<h4 style='margin-top: 10px; text-align: center;'>Oops! No additional information found.</h4>");
        $(".description-div").removeClass("span6");
        $($(objInner).data("href") + "_bg").show();
        $($(objInner).data("href")).show();
        var height = $($(objInner).data("href")).outerHeight();
        var width = $($(objInner).data("href")).outerWidth();
        height = height/2;
        width = width/2;
        $($(objInner).data("href")).attr("style", "margin-left: -" + width + "px ;margin-top: -" + height + "px");
      }
      else {
       
       
        //$(".description-div h1.title").remove();
        $(".description-div").find("a.btn:first").remove();
        $(".description-div .social-sharing").parent().remove();
        
        $(".description-div").removeClass("span6");
        
        $(".description-div").css("text-align", "center");
        $(".description-div p").addClass("adjust-description-p");

        $($(objInner).data("href") + "_bg").show();
        $($(objInner).data("href")).show();
        var height = $($(objInner).data("href")).outerHeight();
        var width = $($(objInner).data("href")).outerWidth();
        height = height/2;
        width = width/2;
        $($(objInner).data("href")).attr("style", "margin-left: -" + width + "px ;margin-top: -" + height + "px");
      }
    });
  });
  $(".closePopup, .nutrition-table-closePopup").click(function() {
    $(lastPopupObj + "_bg").hide();
    $(lastPopupObj).hide();
    lastPopupObj = "";
  });
  /* Step 1 End */
  /* Step 2 Start */
  $(".suprise-click").click(function() {
    if($(window).width() < 767) {
      $('.cust-blur.GYB-bg-blur').removeClass('hide').css({'background-color': 'rgba(0,0,0,0.7)','z-index': '1001' });
      $(".are-you-sure").fadeIn(500);
    }
    else {
      var surpriseQty = $.trim($(".remaining:first").html());
      $.post('/cart/add.js', {
        quantity: surpriseQty,
       // id: "11589973441"
          id: surpriseProductID
      }, function(data) {
        var html = $("#cart_template").val();
        var img = data.image.split("/")[data.image.split("/").length -1];
        img = img.replace(".", "_large.");
        img = data.image.replace(data.image.split("/")[data.image.split("/").length -1], img);
        
        html = html.replace("#itemID#", data.id).replace("#ID#", data.id).replace("#TITLE#", data.product_title + " X " + surpriseQty).replace("#IMG#", img).replace("#QTYADDED#", surpriseQty);
        var isFound = false;
        $(".cart-right li").each(function() {
          if($(this).find(".added-cart").index() == -1 && !isFound) {
            $(html).insertAfter($(this).find(".note-pick"));
            $(this).find(".note-pick").addClass('hide');
            isFound = true;
          }
        });
        var totalItem = parseInt($(".added").html());
        totalItem = parseInt(totalItem) + parseInt(surpriseQty);
        $(".added").html(totalItem);
        $('.cart-items').text(totalItem);
        $(".remaining").html(parseInt(totalAllowedQty) - parseInt(totalItem));
        if(totalItem >= totalAllowedQty) {
          $(".suprise-click").hide();
          $(".surprise-box").fadeOut(500, function() {
            $(".a-proceed-box, .schedule-box").fadeIn(500);
          });
        }
        $(".note-pick:visible").each(function() {
          $(this).closest("li").hide();
        });
      }, 'json');
    }
  });
  $("body.product-body a.proceed").click(function() {
    if($("#chosen-snack-type").val() == "1") {
      /* $.post('/cart/add.js', {
        quantity: 1,
        id: "7133735105" // Mini fabbox variant id
      }, function(data) {
        try {
          $.removeCookie("order_note");
        }
        catch(e) { }
        if($.trim($("#note").val()) != "")
          $.cookie("order_note", $.trim($("#note").val()), { expires: 1 });
        window.location.href = "/cart";
      }, "json"); */
      
      $(".suprise-click:first").click();
      
      if($(window).width() > 767) {
      	window.location.href = "/products/get-your-snackbox-2";
      }
//             setTimeout(function() {
//           	window.location.href = "/products/get-your-snackbox-2";
//            }, 1000);
    }
    else {
      try {
        $.removeCookie("order_note");
      }
      catch(e) { }
      if($.trim($("#note").val()) != "")
          $.cookie("order_note", $.trim($("#note").val()), { path: '/', expires: 1 })
      window.location.href = "/products/get-your-snackbox-2";
    }
    /* $("#step-1").hide();
    $("#step-3").hide();
    $("#step-2").show();
    
    $("#get_your_box_container").load("/pages/step-2 #step_2", function() {
      var body = $("html, body");
      body.stop().animate({scrollTop:0}, '500', 'swing');
    }); */
  });
  $("a.proceed-mobile").click(function() {
    if(parseInt($(".added:first").html()) < 5) {
      $(".suprise-click").click();
    }
    else {
      $("a.proceed").click();
    }
  });
  /* Step 2 End */
  if($(window).width() < 768) {
    $(".goto").click(function() {
      if($(".goto-body").is(":visible")) {
        $(".goto-body").fadeOut(500);
        $(".goto").find("i").removeClass("fa-arrow-circle-o-down").addClass("fa-arrow-circle-o-up");
      }
      else {
        $(".goto-body").fadeIn(500);
        $(".goto").find("i").removeClass("fa-arrow-circle-o-up").addClass("fa-arrow-circle-o-down");
      }
    });
    $(".goto-body a").click(function() {
      $(".goto").click();
    });
  }
  
  // Redirection On click dont-worries-mobile popup
  $('.dont-worries-mobile .yes-button').click( function(){
    window.location.href = "/products/get-your-snackbox-2";
  });
  
  
//   Change next into proceed when 5 items in cart
  //   call while load
  next2proceed ();
  
  //   call while update cart
  $('.popup-cart > .cart-items').bind("DOMSubtreeModified",function(){
    next2proceed ();
  });
  
  function next2proceed () {
    var $ele = $('.popup-cart > .cart-items');
    var $itemCount = parseInt($ele.html());
    
    if($itemCount >= 5) {
      $('a.proceed-mobile.next').html('Proceed >');
    }
    else {
      $('a.proceed-mobile.next').html('Next');
    }
  }
  
  
  
  
//   customers-order-body get your box functionality
  
//   Live
//   var $appAjaxURL = "/apps/fabbox/ajax.php";
//   Staging
  var $appAjaxURL = "/apps/fabbox-app-staging/ajax.php";
  
$('.customers-order-body .product-right-part a.proceed').click(function() {
  
  	$('body').append('<div class="preloader"> <div class="spinner-wrap"><i class="fa fa-spinner fa-pulse fa-fw"></i></div> <div>');
  	
  	var $parent_orderID = $('.order-title').data('parent_order_id');
  	var $scheduleDate = $('#schedule-order-datepicker').val() ? $('#schedule-order-datepicker').val() : '';
    
  	var $line_items = [];
  	$.getJSON("/cart.js", function(data){
      if(Object.keys(data.items).length > 0) {
          $.each(data.items, function(i, item){
           // alert(JSON.stringify(item.variant_id +':'+ item.quantity));
            var $obj = [];
            $obj.push(item.variant_id);
            $obj.push(item.quantity);
            $line_items.push($obj);
          });
      }
      
      var data = "action=next_month_subscription_order&parent_orderID="+$parent_orderID+"&line_items="+$line_items+"&scheduleDate="+$scheduleDate;
      console.log(data);
      $.post($appAjaxURL, data, function(data, status) {
        console.log(data);
        console.log(data.mainData);
//         $('.preloader').remove();
        $('body .preloader').html('<div class="alert alert-success alert-fixed-top alert-box-order fade in"> <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a> Your order ('+ data.mainData +') has been placed successfully! </div>')
        $('.empty-cart').click();
      });	// End of post ajax
      
  	});	// End of cart.js ajax
  
  });	// End of customer-order-page proceed btn
  
  
    $('body.customers-order-body').on('click', '.alert .close', function(){
// 		$('.preloader').remove();
      
      	var firstEmptybox = $('.empty-box').first().attr('id');
      	var hashBox = firstEmptybox.substring(firstEmptybox.indexOf('box'), firstEmptybox.length);
      
      	var reloadURL = location.toString();
        if(location.hash) {
          reloadURL = reloadURL.split('#');
          reloadURL = reloadURL[0];
        }
      	window.location = reloadURL+'#'+hashBox;
      	location.reload();
	});



// if($('.customers-order-body').length){
//   var $parent_orderID = $('.order-title').data('parent_order_id');
//   var $line_items = [];
//   	$.getJSON("/cart.js", function(data){
//       if(Object.keys(data.items).length > 0) {
//           $.each(data.items, function(i, item){
// //             alert(JSON.stringify(item.variant_id +':'+ item.quantity));
//             var $obj = [];
//             $obj.push(item.variant_id);
//             $obj.push(item.quantity);
// //             $obj['variant_id'] = item.variant_id;
// //             $obj['quantity'] = item.quantity;
//             $line_items.push($obj);
//           });
//       }
//       console.log($line_items.toString());
  
// //   var data = "action=next_month_subscription_order&parent_orderID="+$parent_orderID+"&line_items="+$line_items;
// // //         $.post($appAjaxURL, data, function(data, status) {
// // // 			console.log(data);
// // //     	});
	
//     });



// }

      
  
 
});

